import React, { useEffect, useState } from "react";
import {
  add_circle,
  card_gray,
  copy,
  download,
  edit,
  qr_gray,
  share,
  trash_can,
} from "../assets";
import { QRCode } from "react-qrcode-logo";
import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import ModalDelete from "./modals/ModalDelete";
import ModalMissionComplete from "./modals/ModalMissionComplete";
import { deleteCard } from "../constants";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const Cards = ({ cards, mission, setMission }) => {
  const navigate = useNavigate();
  const [missionDone, setMissionDone] = useState(false);
  const [isndef, setIsndef] = useState("NDEFReader" in window);
  const [index, setIndex] = useState(0);
  const [openShare, setOpenShare] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    if (cards.length > 0) {
      setData({ ...cards[index], name: cards[index].card_name });
    }
  }, [index, cards]);

  const handleDownload = () => {
    let canvas = document.getElementById("qr_id");
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `QR-` + cards[index].card_name + `.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      if (
        mission &&
        mission.create_card == true &&
        mission.share_card == false
      ) {
        setMission({
          ...mission,
          share_card: true,
        });
        mission.share_card = true;
        localStorage.setItem("mission", JSON.stringify(mission));
        setMissionDone(true);
      }
      toast.success("QR code downloaded", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleClickShare = (e) => {
    e.preventDefault();
    setOpenShare(!openShare);
  };

  const handleWriteNFC = (e) => {
    e.preventDefault();
    toast.success("Start write to your NFC", {
      position: "top-center",
      autoClose: 2000,
    });
    try {
      const ndef = new NDEFReader();
      ndef
        .write(
          {
            records: [
              {
                recordType: "url",
                data: "https://app.nitomeyocard.com/me/" + cards[index].slug,
              },
            ],
          },
          {
            overwrite: true,
          },
        )
        .then(() => c)
        .catch((error) => {
          console.log(`Write failed try again: ${error}.`);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    if (Boolean(msg)) {
      localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  }, []);

  return (
    <div className="flex flex-col md:flex-row w-full h-full bg-white overflow-y-auto pb-32 md:pb-0">
      <ToastContainer />
      <div className="hidden md:flex flex-col border-0 border-r-2 border-r-gray-200 w-1/5 px-5 py-5 gap-3 text-black">
        <div
          className="flex flex-row items-center gap-2 pb-3 cursor-pointer hover:font-bold active:font-semibold"
          onClick={() => {
            navigate("/card/create");
          }}
        >
          <img src={add_circle} className="w-[20px] h-[20px]" />{" "}
          <div>Add Cards</div>
        </div>
        {cards.map((val, ind) => (
          <div
            className={`cursor-pointer hover:font-bold ${
              ind == index ? "font-bold" : ""
            }`}
            onClick={() => setIndex(ind)}
            key={ind}
          >
            {val.card_name}
          </div>
        ))}
      </div>

      <form className="flex flex-row w-full md:hidden p-5 gap-3 border-b">
        <select
          id="cards"
          className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-5 py-3"
          value={index}
          onChange={(e) => setIndex(e.target.value)}
        >
          {cards.length > 0 ? (
            cards.map((val, ind) => (
              <option key={ind} value={ind}>
                {val.card_name}
              </option>
            ))
          ) : (
            <option>Card</option>
          )}
        </select>
        <div
          className="flex flex-row items-center cursor-pointer hover:font-bold active:font-semibold justify-center w-1/6"
          onClick={() => {
            navigate("/card/create");
          }}
        >
          <img src={add_circle} className="w-[30px] h-[30px]" />{" "}
        </div>
      </form>

      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-2/5 px-10 py-5 gap-3 items-center">
        <div className="flex flex-row justify-between w-full">
          <div>Virtual Cards</div>
          <div className="flex flex-row gap-1">
            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                cards.length > 0
                  ? () => {
                      navigate("/card/update/" + cards[index].card_id);
                      // setCardData(cards[index]);
                      // setBreads([...breads, cards[index].card_name]);
                    }
                  : null
              }
            >
              <img src={edit} alt="edit" className="w-[20px]" />
            </div>

            <div
              id="dropDownShare"
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={cards.length > 0 ? handleClickShare : null}
            >
              <img src={share} alt="share" className="w-[20px]" />
            </div>
            <ul
              id="dropdownMenu"
              className={`${
                openShare ? "" : "hidden"
              } fixed block shadow-lg bg-white py-2 w-full md:w-fit left-0 md:left-[40%] rounded-lg max-h-96 top-10 overflow-auto border`}
            >
              <li className="dropdown-item py-2.5 px-5 flex flex-col items-start gap-2">
                <div className="text-lg font-bold">Share this card</div>
                <div className="flex flex-col md:flex-row gap-5 justify-center items-center">
                  <div className="py-1 px-2 border rounded-lg">
                    {cards.length > 0
                      ? "https://app.nitomeyocard.com/me/" + cards[index].slug
                      : ""}
                  </div>
                  <div
                    className="py-1 px-4 bg-primary text-white hover:bg-secondary w-full md:w-fit text-center cursor-pointer rounded-lg"
                    onClick={
                      cards.length > 0
                        ? () => {
                            navigator.clipboard.writeText(
                              "https://app.nitomeyocard.com/me/" +
                                cards[index].slug,
                            );
                            if (
                              mission &&
                              mission.create_card == true &&
                              mission.share_card == false
                            ) {
                              setMission({
                                ...mission,
                                share_card: true,
                              });
                              mission.share_card = true;
                              localStorage.setItem(
                                "mission",
                                JSON.stringify(mission),
                              );
                              setMissionDone(true);
                            }
                            toast.success("Card's link copied", {
                              position: "top-center",
                              autoClose: 3000,
                            });
                          }
                        : null
                    }
                  >
                    Copy
                  </div>
                </div>
              </li>
            </ul>

            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                cards.length > 0
                  ? () => document.getElementById("delete_modal").showModal()
                  : null
              }
            >
              <img src={trash_can} alt="trash_can" className="w-[20px]" />
            </div>
          </div>
        </div>
        <div className="flex flex-col h-full w-full max-w-[500px] px-0 md:px-10 py-5 justify-center items-center">
          {cards.length == 0 ? (
            <div
              className="flex flex-col bg-gray-300 w-fit justify-center items-center relative rounded-lg z-0"
              id="CardTemplate"
            >
              <img src={card_gray} alt="" className="h-full" />
              <div
                className="bg-primary text-white absolute top-[45%] px-4 py-2 rounded-lg hover:bg-tertiary cursor-pointer"
                onClick={() => {
                  navigate("/card/create");
                }}
              >
                Create Card
              </div>
            </div>
          ) : cards[index].card_template_label == "straight" ? (
            <Card1
              colorFirst={"#" + cards[index].color_theme_value.split(",")[0]}
              colorSecond={"#" + cards[index].color_theme_value.split(",")[1]}
              imageSourceHeader={cards[index].header_image_url}
              imageSourceLogo={cards[index].logo_image_url}
              imageSourceProfile={cards[index].profile_image_url}
              prefix={cards[index].prefix}
              suffix={cards[index].suffix}
              firstName={cards[index].first_name}
              middleName={cards[index].middle_name}
              lastName={cards[index].last_name}
              jobTitle={cards[index].job_title}
              company={cards[index].company}
              aboutMe={cards[index].about_me}
              informations={cards[index].card_social.map((val, ind) => ({
                ...val,
                value: val.input_value,
                image_url: val.icon_image_url,
              }))}
            />
          ) : cards[index].card_template_label == "oval" ? (
            <Card2
              colorFirst={"#" + cards[index].color_theme_value.split(",")[0]}
              colorSecond={"#" + cards[index].color_theme_value.split(",")[1]}
              imageSourceHeader={cards[index].header_image_url}
              imageSourceLogo={cards[index].logo_image_url}
              imageSourceProfile={cards[index].profile_image_url}
              prefix={cards[index].prefix}
              suffix={cards[index].suffix}
              firstName={cards[index].first_name}
              middleName={cards[index].middle_name}
              lastName={cards[index].last_name}
              jobTitle={cards[index].job_title}
              company={cards[index].company}
              aboutMe={cards[index].about_me}
              informations={cards[index].card_social.map((val, ind) => ({
                ...val,
                value: val.input_value,
                image_url: val.icon_image_url,
              }))}
            />
          ) : (
            <Card3
              colorFirst={"#" + cards[index].color_theme_value.split(",")[0]}
              colorSecond={"#" + cards[index].color_theme_value.split(",")[1]}
              imageSourceHeader={cards[index].header_image_url}
              imageSourceLogo={cards[index].logo_image_url}
              imageSourceProfile={cards[index].profile_image_url}
              prefix={cards[index].prefix}
              suffix={cards[index].suffix}
              firstName={cards[index].first_name}
              middleName={cards[index].middle_name}
              lastName={cards[index].last_name}
              jobTitle={cards[index].job_title}
              company={cards[index].company}
              aboutMe={cards[index].about_me}
              informations={cards[index].card_social.map((val, ind) => ({
                ...val,
                value: val.input_value,
                image_url: val.icon_image_url,
              }))}
            />
          )}
        </div>
      </div>
      <div className="flex flex-col w-full md:w-2/5 px-10 py-5 gap-3 h-full divide-y-[1px] divide-gray-200">
        <div className="flex flex-col w-full h-1/2" id="cardQR">
          <div className="flex flex-row justify-between items-center">
            <div>QR Code</div>
            <div
              className="cursor-pointer hover:bg-purple-100 p-2 rounded-lg"
              onClick={cards.length > 0 ? handleDownload : null}
            >
              <img src={download} alt="download" className="w-[20px]" />
            </div>
          </div>
          <div className="flex flex-col py-7 h-full items-center">
            {cards.length > 0 ? (
              <div
                className="flex flex-row rounded-lg w-full max-w-[500px] px-5 py-10 justify-around items-center"
                style={{
                  backgroundColor:
                    "#" + cards[index].color_theme_value.split(",")[0],
                }}
              >
                <div className="flex flex-col gap-1 text-white w-fit justify-center items-center">
                  <img
                    src={cards[index].profile_image_url}
                    className="flex flex-col h-[80px] w-[80px] bg-gray-200 border-white border-4 rounded-full"
                  />
                  <div
                    className="text-[22px] font-bold"
                    style={{
                      color: "#" + cards[index].color_theme_value.split(",")[1],
                    }}
                  >
                    {(cards[index].prefix || "") +
                      " " +
                      (cards[index].first_name || "") +
                      " " +
                      (cards[index].middle_name || "") +
                      " " +
                      (cards[index].last_name || "") +
                      " " +
                      (cards[index].suffix || "")}
                  </div>
                  <div
                    className="text-[14px]"
                    style={{
                      color: "#" + cards[index].color_theme_value.split(",")[1],
                    }}
                  >
                    {cards[index].company
                      ? cards[index].job_title +
                          " at " +
                          cards[index].company || ""
                      : cards[index].job_title}
                  </div>
                </div>
                <QRCode
                  id={"qr"}
                  value={"https://app.nitomeyocard.com/me/" + cards[index].slug}
                  size={100}
                  qrStyle={"dots"}
                  logoOpacity={0.15}
                  bgColor={"transparent"}
                  level={"H"}
                  fgColor={"#" + cards[index].color_theme_value.split(",")[1]}
                />
                <div className="hidden">
                  {" "}
                  <QRCode
                    id={"qr_id"}
                    value={
                      "https://app.nitomeyocard.com/me/" + cards[index].slug
                    }
                    size={500}
                    qrStyle={"dots"}
                    logoOpacity={0.15}
                    bgColor={"transparent"}
                    level={"H"}
                    fgColor={"#" + cards[index].color_theme_value.split(",")[1]}
                    className="hidden"
                  />
                </div>
              </div>
            ) : (
              <div className="flex flex-col rounded-lg w-full justify-center items-center">
                <img
                  src={qr_gray}
                  alt=""
                  className="h-full max-h-[300px] bg-gray-300 rounded-lg"
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col w-full h-1/2 py-10 gap-7" id="shareMsg">
          <div className="flex flex-row justify-between items-center">
            <div>Introduction Message Template</div>
            <div
              className="cursor-pointer hover:bg-purple-100 p-2 rounded-lg"
              onClick={
                cards.length > 0
                  ? () => {
                      navigator.clipboard.writeText(
                        cards[index].intro_message.replace(
                          "{{link}}",
                          "https://app.nitomeyocard.com/me/" +
                            cards[index].slug,
                        ),
                      );
                      if (
                        mission &&
                        mission.create_card == true &&
                        mission.share_card == false
                      ) {
                        setMission({
                          ...mission,
                          share_card: true,
                        });
                        mission.share_card = true;
                        localStorage.setItem(
                          "mission",
                          JSON.stringify(mission),
                        );
                        setMissionDone(true);
                      }
                      toast.success("Introduction message copied", {
                        position: "top-center",
                        autoClose: 3000,
                      });
                    }
                  : null
              }
            >
              <img src={copy} alt="copy" className="w-[20px]" />
            </div>
          </div>
          <div className="p-5 rounded-lg border text-[12px]">
            {cards.length > 0
              ? cards[index].intro_message.replace(
                  "{{link}}",
                  "https://app.nitomeyocard.com/me/" + cards[index].slug,
                )
              : "Enter introduction message Add @[card_name] to insert card’s url"}
          </div>
          {isndef && (
            <div
              className="px-5 py-2 bg-primary text-white rounded-lg hover:bg-secondary cursor-pointer text-center"
              onClick={handleWriteNFC}
            >
              Write to Your NFC Card
            </div>
          )}
        </div>
      </div>
      <ModalDelete type={"card"} data={data} setFunc={deleteCard} />
      {missionDone && <ModalMissionComplete setDone={setMissionDone} />}
    </div>
  );
};

export default Cards;
